'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./node_modules/dom-helpers/util/inDOM.js